<template>
    <div class="learnworlds-main-text learnworlds-main-text-small learnworlds-element" @click="seeAllClicked">
        <a>{{ $t('blog.see_all') }}</a>
    </div>
</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "SeeAll",
        mixins: [ComponentTemplatesMixin],
        props: {
            label: {
                type: String
            },
            display: {
                type: Boolean
            },
            template: {
                type: String
            }
        },
        methods: {
            seeAllClicked () {
                this.emitAction('action-triggered',this.template);
            }
        }
    }
</script>

